<!-- Main Toolbar -->
<div class="relative flex items-center px-4 py-4 justify-between h-16">

  <div>

    <button *ngIf="!tools.checkCurrentPage('PointOfsale') && !hidebackModeBorne  &&shopVisible" (click)="goBack()"
            [ngClass]="cssService.backButton">
      <i class="material-icons text-sm">keyboard_arrow_left</i>
      <span class="text-sm"><span>{{'dialogs.go-back'|translate}} </span></span>
    </button>

    <!--<button mat-stroked-button class="head-btn dark" (click)="openCheckAddress() "
      *ngIf="currSm$ && currSm$.enable_delivery> 0 && tools.checkCurrentPage('Product')" angulartics2On="click"
      angularticsAction="openCheckAddressDialog" angularticsCategory="headers" angularticsLabel="order-side">
      <i class="fas fa-truck whited-ico"></i>
    </button>-->

  </div>

  <div class="flex flex-row gap-2">

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayoutGap.xs="5px">

      <!-- Bouton Mon Compte, connexion ou dashboard si connecté-->
      <button [ngClass]="cssService.toolbarActionButton" *ngIf="!hideRegisterIncrisptionModeBorne" (click)="currUser$ ? goHome() : goLogin(redirectPage)"
              angulartics2On="click" angularticsAction="redirectCustomerSpaceFromHeaderOrder"
              angularticsCategory="customerSpace">
        <i class="material-icons text-sm">face</i>
        <span fxHide.xs>{{ (currUser$ ? currUser$.displayName : ('HeaderOrderComponent.myaccount' | translate)) }}</span>
      </button>

      <mat-icon class="clicked " [matMenuTriggerFor]="menu"
                angulartics2On="click" angularticsAction="redirectProduct" angularticsCategory="headers"
                angularticsLabel="order-side" style="z-index: 101;">more_vert</mat-icon>

    </div>

    <mat-menu #menu="matMenu" angulartics2On="click" angularticsAction="redirectCustomerSpace"
              angularticsCategory="headers" angularticsLabel="order-side">

      <ng-template matMenuContent *ngIf="!hideRegisterIncrisptionModeBorne">

        <button *ngIf="currUser$" mat-menu-item (click)="logOut()" angulartics2On="click" angularticsAction="logout"
                angularticsCategory="headers" angularticsLabel="order-side">
          <mat-icon>exit_to_app</mat-icon>
          <span>{{"header.menu.logout" | translate}}</span>
        </button>

        <button *ngIf="!currUser$ && AccesBornePayment" mat-menu-item
                (click)="borneDevicetoConnect()" angulartics2On="click"
                angularticsAction="borneDevicetoConnect" angularticsCategory="headers" angularticsLabel="order-side">
          <span>{{"header.menu.borne" | translate}}</span>
        </button>

      </ng-template>

      <div fxLayoutAlign="center center" class="layout-padd">
        <app-version></app-version>
      </div>
      <div *ngIf="AccesBornePayment">
        <mat-divider style="margin-top: 10px;"></mat-divider>
        <button mat-menu-item (click)="borneDevicetoConnect()" angulartics2On="click"
                angularticsAction="borneDevicetoConnect" angularticsCategory="headers" angularticsLabel="order-side">
          <mat-icon>settings</mat-icon>
          <span>{{"header.menu.borne" | translate}}</span>
        </button>
      </div>

    </mat-menu>

  </div>

</div>
